import { createContext, useContext } from 'react'

/**
 * When the chat stream stops (status='ready') but a tool part never reached
 * 'output-available' or 'error', the tool is effectively failed.  This context
 * lets ToolStatusLine detect that case without plumbing a prop through every
 * tool component.
 */
export const ChatStoppedContext = createContext(false)
export const useChatStopped = () => useContext(ChatStoppedContext)
